import React from "react";
import { Modal } from "react-bootstrap";
import { IMAGE_URL } from "../../services/api";
import ProtectedImage from "../../components/ProtectedImage";
const CompanyViewModal = ({ show, handleClose, company }) => {
  if (!company) return null;

  return (
    <Modal show={show} onHide={handleClose} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title>{company.company_name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center mb-3">
          <ProtectedImage
            path={company.company_logo}
            alt="Company Logo"
            style={{
              width: "100px",
              height: "100px",
              objectFit: "cover",
              borderRadius: "8px",
              border: "1px solid #ddd",
              padding: "4px"
            }}
          />
          {/* <img
            src={`${IMAGE_URL}${company.company_logo}`}
            alt="Company Logo"
            style={{
              width: "100px",
              height: "100px",
              objectFit: "cover",
              borderRadius: "8px",
              border: "1px solid #ddd",
              padding: "4px",
            }}
          /> */}
        </div>
        <p>
          <strong>Description:</strong> {company.description}
        </p>
        <p>
          <strong>Location:</strong> {company.location}
        </p>
        <p>
          <strong>Employee Strength:</strong> {company.employee_strength}
        </p>
      </Modal.Body>
    </Modal>
  );
};

export default CompanyViewModal;
